<template>
    <div>
      <b-container class="p-3" fluid>
        <b-row>
          <b-col class="">
            <h4 class="">All Competitions</h4>
            <b-skeleton-wrapper
              class="text-center"
              :loading="testspacearray.length <= 0"
            >
              <template #loading>
                <b-skeleton width="100%"></b-skeleton>
              </template>
              <h6 class="">
                {{ testspacearray.length }} Competition{{
                  testspacearray.length > 1 ? "s" : ""
                }}
              </h6>
            </b-skeleton-wrapper>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="m-0 p-3">
  
            <b-skeleton-wrapper class="text-center mt-3" :loading="loading">
              <template #loading>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
              </template>
            </b-skeleton-wrapper>
  
            <b-form-group class="nested-form-group" label-for="institution">
              <b-input-group class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  type="search"
                  v-model="searchQuery"
                  @keyup="searchFilter"
                  @focus="searching = true"
                  placeholder="Search"
                ></b-form-input>
                <b-icon
                  font-scale="1.5"
                  class="close-button"
                  @click="closeSearch"
                  variant="secondary"
                  icon="x"
                  ref="closebutton"
                ></b-icon>
              </b-input-group>
            </b-form-group>
  
            <b-table
              v-if="testspacearray.length > 0 && !loading"
              striped
              hover
              responsive
              head-variant="dark"
              class="tablerr"
              :items="usetestspacearray"
              :fields="headers"
            >
              <template #cell(sn)="data">
                {{ data.index + 1 + (pages - 1) * intervalnum }}
              </template>
              <template #cell(test_institution)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(test_group)="data">
                <span>{{ data.item.test_institution }}</span>
              </template>
              <template #cell(test_code)="data">
                <span>{{ data.item.trx_code }}</span>
              </template>
              <template #cell(no_of_candidates)="data">
                <span>{{ JSON.parse(data.item.test_takers).length }}</span>
              </template>
              <template #cell(test_status)="data">
                <span>
                  <b-badge
                    :disabled="true"
                    :variant="
                      data.item.test_status == 'Closed' ? 'danger' : 'success'
                    "
                    >{{ data.item.test_status }}</b-badge
                  >
                </span>
              </template>
              <template #cell(action)="data">
                <div>
                  <b-icon-three-dots-vertical
                    :id="`popover-1-table-ts`"
                    variant="primary"
                  ></b-icon-three-dots-vertical>
                  <b-popover
                    :target="`popover-1-table-ts`"
                    placement="bottomright"
                    title=""
                    triggers="hover focus"
                  >
                    <div style="width: 170px; min-height: 40px" class="">
                      <div
                        @click="
                          $router.push({
                            name: 'viewtestspace',
                            params: { trackid: data.item.track_id },
                            query: { type : 'competition'}
                          })
                        "
                        class="cursor-pointer action-link p-1 px-2"
                      >
                        <p class="text-sm">View</p>
                      </div>
                      <div
                        @click="
                          $router.push({
                            name: 'createtestspaces',
                            params: { trackid: data.item.track_id },
                            query: { type : 'competition'}
                          })
                        "
                        class="cursor-pointer action-link p-1 px-2"
                      >
                        <p class="text-sm">Edit</p>
                      </div>
                      <div
                        @click="
                          $router.push({
                            name: 'viewtestspace',
                            params: { trackid: data.item.track_id },
                            query: { type : 'competition'}
                          })
                        "
                        class="cursor-pointer action-link p-1 px-2"
                      >
                        <p class="text-sm">Space Stats</p>
                      </div>
                      <div
                        @click="
                          $router.push({
                            name: 'viewtestspace',
                            params: { trackid: data.item.track_id }
                          })
                        "
                        class="cursor-pointer action-link p-1 px-2"
                      >
                        <p class="text-sm">Share Link</p>
                      </div>
                      <div class="cursor-pointer action-link p-1 px-2">
                        <p class="text-sm">Delete</p>
                      </div>
                    </div>
                  </b-popover>
                </div>
              </template>
            </b-table>
  
            <div class="text-center mt-5" v-if="testspacearray.length <= 0">
              No Data to show
            </div>
          
            <paginater
              :intervalnum="intervalnum"
              :pages="pages"
              :endnum="endnum"
              :endss="endss"
              :datalength="endss"
              @paginator="newPage"
              @changeInterval="effectInterval"
            ></paginater>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>
  
  <script>
  import Paginater from "@/components/Paginater";
  
  import { mapState, mapActions } from "vuex";
  
  export default {
    components: {
      Paginater
    },
    data() {
      return {
        startnum: 0,
        limitnum: this.endss,
        intervalnum: 10,
        endnum: 10,
        btnrange: this.endss,
        pages: 1,
        stockingdata: [
          {
            data: []
          }
        ],
        dataretrieved: false,
        searchQuery: "",
        searching: false,
        loading: false
      };
    },
    mounted() {
      let curpage = 1;
      this.endnum = this.endnum * Number(curpage);
      this.pager = curpage;
  
      this.fetchData();
    },
    methods: {
      ...mapActions("admin", ["setQuery", "fetchCompetitions"]),
      async fetchData() {
        this.loading = true;
        try {
          await this.fetchCompetitions();
          this.endnum = this.meta.perPage * Number(this.meta.page);
          this.loading = false;
        } catch (err) {
          console.log(err);
        }
      },
      newPage(page) {
        // alert(page)
        this.pages = page;
        //   let newend = this.intervalnum * page;
  
        let search = this.searchQuery.length > 0 ? `&search=${this.searchQuery}` : "";
        this.setQuery(`page=${this.pages}&perPage=${this.intervalnum}${search}`);
        this.fetchData()
      },
      effectInterval(newinterval) {
        this.intervalnum = newinterval;
        this.pages = 1;
        this.newPage(this.pages);
      },
      clearField() {
        this.searchQuery = "";
        this.closeSearch();
      },
  
      async searchFilter() {
        this.searching = true;
        //   let query = this.searchQuery;
  
        try {
          if (this.searchQuery.length == 0) {
            this.clearField();
            this.setQuery(`page=${this.pages}&perPage=${this.intervalnum}`);
            await this.fetchCompetitions();
            this.searching = false;
          } else {
            this.setQuery(
              `page=${this.pages}&perPage=${this.intervalnum}&search=${this.searchQuery}`
            );
            await this.fetchCompetitions();
            this.searching = false;
          }
        } catch (err) {
          console.log(err);
        }
      },
      closeSearch() {
        this.searching = false;
        this.searchQuery = "";
      }
    },
  
    computed: {
      ...mapState({
        testspacearray: state => state.admin.listtestspaces.data,
        meta: state => state.admin.listtestspaces.meta,
        details: state => state.loginmaster.details
      }),
  
      headers() {
        return [
          "sn",
          this.details.clearance_organization == "Quicktest"
            ? "test_institution"
            : "test_group",
          "test_title",
          "test_code",
          "no_of_candidates",
          "test_startdate",
          "test_enddate",
          "test_status",
          "test_state",
          "action"
        ];
      },
  
      usetestspacearray() {
        return this.testspacearray;
      },
      endss() {
        let end = this.meta.total;
        return end;
      },
      ranger() {
        let ranger = Math.ceil(this.testspacearray.length / this.intervalnum);
        return ranger;
      },
      retrieving() {
        //let trid = this.$route.params.trackid;
  
        let curres = this.testspacearray.length;
        //this.result = curres;
  
        if (curres <= 0) {
          return true;
        } else {
          return false;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .allrewr {
    min-height: 70vh;
    background-color: white;
    border-radius: 20px 20px;
  }
  
  .list-heads {
    background-color: #00984a;
    color: white;
    border-radius: 5px 5px;
    font-weight: bold;
    display: flex;
    flex-flow: row wrap;
  }
  
  .viewmore {
    background-color: rgb(241, 234, 234);
    border-radius: 100px;
    width: 50px;
    height: 50px;
    margin: 0px auto;
    box-shadow: 5px 5px 15px black;
    cursor: pointer;
  }
  
  .maxres {
    border-radius: 5px 5px;
  }
  
  .maxres:hover {
    background-color: #eeeeee;
  }
  
  .vmore {
    margin: 5px;
    padding: 10px;
  }
  
  .spinver {
    width: 7rem;
    height: 7rem;
  }
  .head-p {
    width: 15%;
    padding: 2px;
  }
  
  .page-buttons {
    width: 35px;
    height: 35px;
  }
  .active-page-btn {
    background-color: #00377b;
    color: white;
  }
  .button-pager-group {
    overflow-x: auto;
    scroll-behavior: smooth;
    scrollbar-width: thin;
  }
  
  @media screen and (max-width: 999px) {
    .head-p {
      font-size: 0.6rem;
    }
    .page-buttons {
      width: 25px;
      height: 25px;
      padding: 0px 0px 0px 5px;
    }
  }
  </style>
  